<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
let customerId = window.localStorage.getItem("customerId");
import Vue from "vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "consumablesClass",
        key: "id",
        url: {
          del: "/admin/system/consumableType",
        },
        output: false,
      },
      actions: [],
      menus: [],
      filters: [
        {
          label: "耗材分类",
          KeyEnter: this.search,
          name: "model",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "耗材分类",
          key: "model",
          minWidth: 300,
          align: "left",
        },

        {
          title: "分类编号",
          key: "sigillum",
          minWidth: 300,
          align: "left",
        },
        {
          title: "创建时间",
          width: 200,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime ? row.createTime.slice(0, 16) : null;
            return <span>{text}</span>;
          },
        },
        // {
        //   title: '创建人',
        //   minWidth: 180,
        //   align: 'left',
        //   key: 'createBy',
        // },
      ],
    };
  },
  created() {
    if (Number(customerId) === 0) {
      this.tableCols.push({
        title: "操作",
        align: "center",
        width: 150,
        key: "handle",
        fixed: "right",
        // show:Number(customerId) === 0 ? "yes":"no",
        handle: ["edit", "delete"],
        auth: {
          edit: "system/consumablesClass/edit",
          del: "system/consumablesClass/delete",
        },
      });
      this.actions.push({
        label: "新增",
        icon: "md-add",
        onClick: this.toAdd,
        type: "info",
        auth: "system/consumablesClass/add",
      });
    }
  },
  methods: {
    toAdd() {
      $utils.url.push({
        name: "consumablesClass_add",
        query: { action: "add" },
      });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "consumablesClass_edit",
        query: { action: "edit", kv: kv },
      });
    },
  },
};
</script>
<style scoped></style>
